import { useEffect, useState } from "react";
import {
    DKLabel,
    DKButton,
    DKInput,
    INPUT_VIEW_DIRECTION,
    DKCheckMark,
    DKTooltipWrapper,
    DKIcon,
    DKExpandableWrapper,
    DKRadioButton,
    DKLine,
    removeLoader,
    DKSpinner,
    showLoader,
    showToast,
    TOAST_TYPE} from "deskera-ui-library"
import { IR8S_FORM_CONFIG , IR8A_EXTERNAL_FIELDS, Genders, IR8A_BANKDETAILS, IR8A_APPROVAL_OBTAIN_LIST, EXEMPT_REMISSION_INCOME_LIST, EMPLOYEE_INCOME_TAX_BORN_BY_EMPLOYER_LIST, SECTION_45_INDICATOR} from "./SGReportsConstant";
import { CONSTANTS, FORMAT, INPUT_TYPE } from "../../../../constants/Constant";
import MaskInput from "../../../../SharedComponents/MaskInput/MaskInput";
import MaskInputUtil from "../../../../SharedComponents/MaskInput/MaskInputUtil";
import Utility, { deepClone } from "../../../../utility/Utility";
import ic_info_message from "../../.../../../../assets/icons/ic_info_gray01.png";
import {ERF} from "../../../../constants/Constant"
import EmployeeListService from "../../../../services/EmployeeListService";
import { useDispatch, useSelector } from "react-redux";
import { fetchFormEmployeeDetails,selectFormEmployeeDetails } from "../../../../Redux/Slices/SGFormsSlice";
import { getTenantCountryCode, removeFirstDecimalFromInput, scrollToError } from "../../../../managers/common/CommonUtil"
import { Nationalities } from "../../../../constants/CountryConstant";
import { selectCPFAccounts } from "../../../../Redux/Slices/EmployeeListSlice";
import { Countries } from "../../../add-employee/steps/Employee";
import moment from "moment";
import IRASService from "../../../../services/IRASService";

const IR8AForm = (props) => {

    const [IR8AFormConfig, setIR8AFormConfig] = useState(IR8S_FORM_CONFIG);
    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable =
        MaskInputUtil.subscripeToMaskUnmaskObservable(setMask);
    const [formValues, setFromValues] = useState({});
    const [formDetails, setFromDetails] = useState(props?.data?.formDetails);
    const [isLoading, setIsLoading] = useState(true);

    /**Selector */
    const employeeDetails = useSelector(selectFormEmployeeDetails);
    const cpfAccountDetails = useSelector(selectCPFAccounts);

    /**Dispatcher */
    const dispatch = useDispatch()
    
    useEffect(()=> {
        loadEmployeeDetails(props.data.userId);
    },[]);

    useEffect(() => {
        if(!Utility.isEmpty(employeeDetails) && employeeDetails?.user?.userId === props.data.userId) {
            updateIR8AFormConfig();
            updateFormValues();
        }
    },[employeeDetails])

    const loadEmployeeDetails = async (userId) => {
        try {
          const config = {
            ...EmployeeListService.apiConfig,
            getComponents: true,
            getCompliance: true,
            getBenefits: false,
            customFieldModule: "",
          };
          EmployeeListService.apiConfig = config;
          await dispatch(fetchFormEmployeeDetails(userId));
    
        } catch (err) {
          removeLoader();
          console.error("Error loading employee details: ", err);
        }
      };

    const onChange = (value, fieldIndex, field, sectionIndex) => {
        const alteredConfig = [];
        const config = deepClone(IR8AFormConfig);
        if(field?.columnCode === 'C') {
            const index = config[sectionIndex].fields?.findIndex(f=>f.columnCode === 'directorFeesApprovalDate') || -1
            if(value && value>0 && index != -1) {
                config[sectionIndex].fields[index].validation = ['required']
            } else {
                config[sectionIndex].fields[index].validation = []
            }
        }
        let {isValid, errMsg} = checkFieldValidation(field, value);
        if(isValid) {
            value = removeFirstDecimalFromInput(value)
            formValues[field.columnCode] = value;
            alteredConfig.push({columnCode:field.columnCode, hasError: !isValid, errMsg : errMsg});
        } else {
            formValues[field.columnCode] = value;
            alteredConfig.push({columnCode:field.columnCode, hasError: !isValid, errMsg : errMsg});
        }
        alterFormFieldConfig([field], formValues, config, sectionIndex);
        EmployeeListService.getAlteredSectionConfigDetails(config, alteredConfig, "fields", sectionIndex);
        setIR8AFormConfig(config);
    }

    const onCheck = (field) => {
        formValues[field.columnCode] = !formValues[field.columnCode];
        setFromValues(deepClone(formValues));
    }

    const getFieldRequired = (field) => {
        const validator = field.validation;
        let isRequired = false;
        if(validator && validator.some(x => x === "required")) isRequired = true;
        return isRequired;

    }

    const updateIR8AFormConfig = () => {
        if(!Utility.isEmpty(formDetails?.length)) {
            const formDetail = formDetails[0];
            const categories = formDetail?.categories;
            const othersIndex = categories.findIndex(c=> c.displaySeq === "Others");
            const others = othersIndex != -1 ? categories[othersIndex] : {};
            const formConfigs = deepClone(IR8AFormConfig)
            if(!Utility.isEmpty(categories)) {
                IR8A_EXTERNAL_FIELDS.forEach(externalField => {
                    let index = categories.findIndex(x=> x.displaySeq === externalField.columnCode);
                    if(index != -1) {
                        updateConfigFields(externalField, categories[index], formConfigs)
                    } else {
                        let indexOthers = others?.categories?.findIndex(x=> x.displaySeq === externalField.columnCode);
                        if(indexOthers != -1) {
                            updateConfigFields(externalField, others.categories[indexOthers], formConfigs);
                        }
                    }
                });
            }
            setIR8AFormConfig(formConfigs);
        }
    }

    const updateFormValues = () => {
        const configData = formDetails[0];
        const userData = employeeDetails?.user;
        formValues['employee'] = !Utility.isEmptyObject(configData['fullNameOfEmployee'])
            ? configData['fullNameOfEmployee']
            : configData['employeeName'];
        formValues['sex'] = !configData['sex'] && userData.gender !== CONSTANTS.EMPTY_STRING
            ? EmployeeListService.getValueObjectFromDropdown(userData.gender, Genders, "id")
            : EmployeeListService.getValueObjectFromDropdown(configData.sex, Genders, "id");
        formValues['designation'] =
            !configData['designation'] && userData.designation !== CONSTANTS.EMPTY_STRING
                ? userData.designation
                : configData['designation'];
        formValues['dateOfBirth'] =
            !configData['dateOfBirth'] && userData.dateOfBirth !== CONSTANTS.EMPTY_STRING
                ? getDateValueForForm(userData.dateOfBirth)
                : getDateValueForForm(configData['dateOfBirth']);
        formValues['dateOfCommensement'] =
            !configData['dateOfCommensement'] &&
                userData['dateOfJoining'] !== CONSTANTS.EMPTY_STRING
                ? getDateValueForForm(userData['dateOfJoining'])
                : getDateValueForForm(configData['dateOfCommensement']);
        formValues['nationality'] =
            !configData['nationality'] &&
                userData['hasCompliance'] &&
                userData['compliance'].nationality
                ? EmployeeListService.getValueObjectFromDropdown(userData['compliance'].nationality, Nationalities, "id")
                : EmployeeListService.getValueObjectFromDropdown(configData['nationality'], Nationalities, "id");
        formValues['nricNo'] =
            !configData['nricNo'] &&
                userData['hasCompliance'] &&
                userData['compliance'].nric
                ? userData['compliance'].nric
                : configData['nricNo'];
        formValues['finNo'] = !configData['finNo'] &&
            userData['hasCompliance'] &&
            userData['compliance'].fin
            ? userData['compliance'].fin
            : configData['finNo'];
        !configData['address'] && userData['address'] !== CONSTANTS.EMPTY_STRING
            ? getAddressObject(userData['address'])
            : getAddressObject(configData['address']);
        formValues["country"] = getCountryObject(configData);
        formValues["employeeNricFin"] = !Utility.isEmpty(configData["finNo"]) ? configData["finNo"] : (!Utility.isEmpty(configData["nricNo"]) ? configData["nricNo"]: (!Utility.isEmpty(formValues["finNo"]) ? formValues["finNo"] : formValues["nricNo"]));
        formValues["fullNameOfEmployee"] = configData['employeeName'];
        formValues["bankOfSalaryCredit"] = EmployeeListService.getValueObjectFromDropdown(configData["bankOfSalaryCredit"], IR8A_BANKDETAILS, "id");
        formValues["dateOfCessation"] = getDateValueForForm(configData["dateOfCessation"]);
        formValues["bonusDeclarationDate"] = getDateValueForForm(configData["bonusDeclarationDate"]);
        formValues["directorFeesApprovalDate"] = getDateValueForForm(configData["directorFeesApprovalDate"]);
        formValues["section45Indicator"] = EmployeeListService.getValueObjectFromDropdown(configData["section45Indicator"], SECTION_45_INDICATOR, "id");
        formValues["commissionPaymentFrom"] = getDateValueForForm(configData["commissionPaymentFrom"]);
        formValues["commissionPaymentTo"] = getDateValueForForm(configData["commissionPaymentTo"]);
        formValues["lossOfOffice"] = configData["lossOfOffice"];
        formValues["compensationLossofOfficeAmount"] = getLossOfOfficeAmount(configData);
        formValues["ir8sApprovalObtained"] = EmployeeListService.getValueObjectFromDropdown(configData["ir8sApprovalObtained"], IR8A_APPROVAL_OBTAIN_LIST, "id");
        formValues["ir8sApprovalDate"] = getDateValueForForm(configData["ir8sApprovalDate"]);
        formValues["exemptRemissionIncomeIndicator"] = EmployeeListService.getValueObjectFromDropdown(configData["exemptRemissionIncomeIndicator"], EXEMPT_REMISSION_INCOME_LIST, "id");
        formValues["exemptIncomeTaxRemission"] = configData["exemptIncomeTaxRemission"];
        formValues["employeeIncomeTaxBorneByEmployerIndicator"] = EmployeeListService.getValueObjectFromDropdown(configData["employeeIncomeTaxBorneByEmployerIndicator"], EMPLOYEE_INCOME_TAX_BORN_BY_EMPLOYER_LIST, "id");
        formValues["employmentIncomeTaxbyEmployer"] = configData["employmentIncomeTaxbyEmployer"];
        formValues["fixedAmountIncomeTaxbornebyEmployee"] = configData["fixedAmountIncomeTaxbornebyEmployee"];
        formValues["insurance"] = configData["insurance"] ? parseInt(configData["insurance"]) : 0;
        formValues["donation"] = configData["donation"] ? parseInt(configData["donation"]) : 0;
        setAdditonalFormValues(configData);
        if (!configData['uenNo'] && userData['hasCompliance'] && cpfAccountDetails?.accounts) {
            const cpfAccIndex = cpfAccountDetails?.accounts.findIndex(a => a['accountId'] === userData['compliance'].assignCPFAccount);
            formValues['employeeUen'] =
                cpfAccountDetails?.accounts[cpfAccIndex]?.['compliance']
                    ? cpfAccountDetails.accounts[cpfAccIndex]['compliance']['organizationIdNumber']
                    : configData['uenNo'];
        } else {
            formValues['employeeUen'] = configData['uenNo'];
        }
        setIsLoading(false);
    }

    const getAddressObject = (addressObject) => {
        formValues["addressLine1"] = addressObject.addressLine1;
        formValues["addressLine2"] = addressObject.addressLine2;
        formValues["zipCode"] = addressObject.zipCode;
        formValues["city"] = addressObject.city;
        formValues["state"] = addressObject.state;
    }

    const getCountryObject = (configData) => {
        if(!Utility.isEmpty(configData?.address?.country)) {
            const country = EmployeeListService.getValueObjectFromDropdown(configData.address.country, Countries, "code");
            return {id: country.code, name: country.name, ...country}
        } else {
            const country = EmployeeListService.getValueObjectFromDropdown(getTenantCountryCode(), Countries, "code");
            return {id: country.code, name: country.name, ...country}
        }
    }
    
    const setAdditonalFormValues = (configData) => {
        if (configData?.compliance?.employeeContribution) {
            const employeeContribution = configData.compliance.employeeContribution;
            formValues["employeeCpfContribution"] = parseInt(employeeContribution.cpfContribution);
            formValues["employeeMbmfContribution"] = parseInt(employeeContribution['mbmf']);
          } else {
            formValues["employeeCpfContribution"] = 0;
            formValues["employeeMbmfContribution"] = 0;
          }
    }

    const getLossOfOfficeAmount = (configData) => {
        let amount;
          if (configData?.categories){
              const otherCategoriesIndex = configData?.categories.findIndex(c => c.displaySeq === "Others");
              if (otherCategoriesIndex != -1) {
                  const otherCategories = configData.categories[otherCategoriesIndex];
                  const compensation = otherCategories.categories.find((comp)=>{
                    return comp.name === "Compensation";
                  })
                  if (compensation && compensation.amount) {
                    amount = compensation.amount
                  }
              }
          }
        return amount;
      }
    
    const getDateValueForForm = (value) => {
        if(!Utility.isEmpty(value)) return moment(value, FORMAT.YYYYMMDD).toDate();
        return value;
    }

    const updateConfigFields = (externalFields, field, formConfigs) => {
        const group = {
            columnCode: field.displaySeq,
            name: !Utility.isEmpty(externalFields.name) ? externalFields.name : field.name,
            type: INPUT_TYPE.NUMBER,
        };
        let isDecimalNotAllowed = true;
        if (!Utility.isEmpty(externalFields.validation)) {
            group["validation"] = externalFields.validation;
            isDecimalNotAllowed = externalFields.validation.some(x=> x === "noDecimal");
        };
        formConfigs[externalFields.expextedSection-1].fields.splice(externalFields.expectedFieldPosition-1,0,group);
        formValues[field.displaySeq] = !Utility.isEmpty(field.amount) ? (isDecimalNotAllowed ? parseInt(field.amount) : field.amount) : 0;
        alterFormFieldConfig([group], formValues, formConfigs, externalFields.expectedFieldPosition-1)
    }

    const alterFormFieldConfig = (fields, values, formFields, sectionIndex) => {
        const alteredConfig = [];
        fields.forEach((field) => {
            switch(field.columnCode) {
                case "B":
                    if (!Utility.isEmpty(parseInt(values[field.columnCode]))) {
                        alteredConfig.push({columnCode:"bonusDeclarationDate", validation:["required"], readOnly:false});
                    } else {
                        alteredConfig.push({columnCode:"bonusDeclarationDate", validation:[], readOnly: true});
                    }
                    break;
                case "C":
                    sectionIndex = formFields?.findIndex(f=>f.title == 'Income');
                    if (!Utility.isEmpty(parseInt(values[field.columnCode]))) {
                        alteredConfig.push({columnCode:"directorFeesApprovalDate", validation:["required"], readOnly: false});
                    } else {
                        alteredConfig.push({columnCode:"directorFeesApprovalDate", validation:[], readOnly: false});
                    }
                    break;
                case "D2":
                    if(!Utility.isEmpty(parseInt(values[field.columnCode]))) {
                        alteredConfig.push({columnCode:"commissionPaymentFrom", validation:["required", "lessThan"]});
                        alteredConfig.push({columnCode:"commissionPaymentTo", validation:["required","greaterThan"]});
                    } else {
                        alteredConfig.push({columnCode:"commissionPaymentFrom", validation:["lessThan"]});
                        alteredConfig.push({columnCode:"commissionPaymentTo", validation:["greaterThan"]});
                    }
                    break;
                case "ir8sApprovalObtained":
                    const obtained = EmployeeListService.getSelectedIdFromObject(values[field.columnCode], "id")
                    if(!Utility.isEmpty(obtained) && obtained === "Y") {
                        alteredConfig.push({columnCode:"ir8sApprovalDate", validation:["required"]});
                    } else if(!Utility.isEmpty(obtained) && obtained === "N") {
                        alteredConfig.push({columnCode:"ir8sApprovalDate", validation:[], readOnly: true});
                    }
                    break;
                case "commissionPaymentFrom":
                    const dateTo = moment(formValues["commissionPaymentTo"]);
                    const dateFrom = moment(formValues["commissionPaymentFrom"]);
                    if (dateTo && dateFrom && dateTo.isSameOrBefore(dateFrom)) {
                        const errMsg = "End of Period of gross commission should be after Start of Period of gross commission"
                        alteredConfig.push({columnCode:"commissionPaymentTo", hasError: true, errMsg : errMsg});
                    } else {
                        alteredConfig.push({columnCode:"commissionPaymentTo", hasError: false, errMsg : ""});
                    }
                    break;
                case "commissionPaymentTo":
                    const dateFrom1 = moment(formValues["commissionPaymentFrom"]);
                    const dateTo1 = moment(formValues["commissionPaymentTo"]);
                    if (dateFrom1 && dateTo1 && dateFrom1.isSameOrAfter(dateTo1)) {
                        const errMsg = "Start of Period of gross commission should be before End of Period of gross commission"
                        alteredConfig.push({columnCode:"commissionPaymentFrom", hasError: true, errMsg : errMsg});
                    } else {
                        alteredConfig.push({columnCode:"commissionPaymentFrom", hasError: false, errMsg : ""});
                    }
                    break;
    
            }
        });
        EmployeeListService.getAlteredSectionConfigDetails(formFields,alteredConfig, "fields", sectionIndex);
    }

    const checkFieldValidation = (field, value) => {
        let isValid = true;
        let errMsg = CONSTANTS.EMPTY_STRING;
        field?.validation?.forEach((v) => {
            switch(v) {
                case "required":
                    if(Utility.isEmpty(value)) {
                        isValid = false;
                        errMsg = `Enter a valid ${field.name}`
                    }
                    break;
                case "noDecimal":
                    if(typeof(value) === "string" && value.includes(".")) {
                        isValid = false;
                        errMsg = "Decimal value is not allowed"
                    } else if(typeof(value) === "number" && (value - Math.floor(value)) !== 0) {
                        isValid = false;
                        errMsg = "Decimal value is not allowed"
                    }
                    break;
                case "minLength":
                    if(value?.length < field.minLength) {
                        isValid = false;
                        errMsg = `Charaters should be minimum of ${field.minLength} letters`;
                    }
                    break;
                case "maxLength":
                    if(value?.length > field.maxLength) {
                        isValid = false;
                        errMsg = `Length should not exceed ${field.maxLength} digits`;
                    }
                    break;
                case "lessThan":
                    if(!Utility.isEmpty(field.lessThanFields)) {
                        field?.lessThanFields.forEach((f) => {
                            if(!Utility.isEmpty(formValues[f.key])) {
                                const date1 = moment(value);
                                const date2 = moment(formValues[f.key]);
                                if(date1 && date2 && date1.isSameOrAfter(date2)) {
                                    isValid = false;
                                    errMsg = `${field.name} should be before ${f.name}`
                                }
                            }
                        })
                    }
                    break;
                case "greaterThan":
                    if(!Utility.isEmpty(field.greaterThanFields)) {
                        field?.greaterThanFields.forEach((f) => {
                            if(!Utility.isEmpty(formValues[f.key])) {
                                const date1 = moment(value);
                                const date2 = moment(formValues[f.key]);
                                if(date1 && date2 && date1.isSameOrBefore(date2)) {
                                    isValid = false;
                                    errMsg = `${field.name} should be after ${f.name}`
                                }
                            }
                        })
                    }
                    break;

            }
        });
        return {isValid:isValid, errMsg: errMsg}
    }

    const isValidSubmission = () => {
        const config = deepClone(IR8AFormConfig);
        const totalAlteredConfig=[];
        let isValid = true;
        config.forEach((s, index) => {
            const alteredConfig=[];
            s.fields.forEach((f) => {
                const {isValid, errMsg} = checkFieldValidation(f, formValues[f.columnCode]);
                if(!isValid) {
                    alteredConfig.push({columnCode : f.columnCode, hasError: !isValid, errMsg: errMsg});
                    totalAlteredConfig.push({columnCode : f.columnCode, hasError: !isValid, errMsg: errMsg});
                }
            });
            EmployeeListService.getAlteredSectionConfigDetails(config, alteredConfig, "fields", index);
        });
        if(!Utility.isEmpty(totalAlteredConfig.length)) {
           scrollToError(totalAlteredConfig[0]?.columnCode);
           isValid = false;
        }
        setIR8AFormConfig(config);
        return isValid;
    }

    const onSave = () => {
        if(!isValidSubmission()) {
            return;
        }
        try {
            showLoader("Updating form... Please wait");
            const parameter = getParameters();
            IRASService.updateIR8AFormDetails(parameter, parameter.id).then((response) => {
                if(response) {
                    showToast("Form updated successfully", TOAST_TYPE.SUCCESS);
                    if (props.onClose()) props.onClose();
                }
                removeLoader();
            })
        } catch (err) {
            removeLoader();
            showToast("Something went wrong", TOAST_TYPE.ERROR)
        }
    }

    const getParameters = () => {
        let parameter = {};
        const details = deepClone(formDetails[0]);
        for(const key in details) {
            switch(key) {
                case "address":
                    parameter["address"] = getAddressObjectForSave(details[key]);
                    break;
                case "categories":
                    parameter["categories"] = getCategoriesObjectForSave(details[key]);
                    break;
                case "commissionPaymentFrom":
                    parameter[key] = getDateValueForSave(details, key);
                    break;
                case "commissionPaymentTo":
                    parameter[key] = getDateValueForSave(details, key);
                    break;
                case "compliance":
                    parameter[key] = getComplainceObjectForSave(details, key);
                    break;
                case "uenNo":
                    parameter["uenNo"] = formValues["employeeUen"];
                    break;
                case "nricNo":
                    parameter["nricNo"] = !Utility.isEmpty(details["nricNo"]) ? formValues["employeeNricFin"] : details["nricNo"];
                    break;
                case "finNo":
                    parameter["finNo"] = !Utility.isEmpty(details["nricNo"]) ? details["finNo"] : formValues["employeeNricFin"];
                    break;
                case "payrollDate":
                    parameter[key] = details[key];
                    break;
                case "dateOfBirth":
                case "dateOfCommensement":
                case "dateOfCessation":
                case "directorFeesApprovalDate":
                case "ir8sApprovalDate":
                case "bonusDeclarationDate":
                    parameter[key] = getDateValueForSave(details, key);
                    break;
                default:
                    if(!Utility.isEmpty(formValues[key]) && !key.includes("date") && typeof(formValues[key]) === "object") {
                        parameter[key] = EmployeeListService.getSelectedIdFromObject(formValues[key],"id");
                    } else if(!Utility.isEmpty(formValues[key]) && typeof(formValues[key]) !== "object") {
                        parameter[key] = formValues[key];
                    } else if(key.includes("date")) {
                        parameter[key] = getDateValueForSave(details, key);
                    } else {
                        parameter[key] = details[key];
                    }
            }
        }
        return parameter;
    }

    const getAddressObjectForSave = (addressObject) => {
        let parameter = {};
        for(const key in addressObject) {
            if(!Utility.isEmpty(formValues[key]) && typeof(formValues[key]) != "object") {
                parameter[key] = formValues[key];
            } else if(!Utility.isEmpty(formValues[key]) && typeof(formValues[key]) === "object") {
                parameter[key] = EmployeeListService.getSelectedIdFromObject(formValues[key],"id");
            } else {
                parameter[key] = addressObject[key];
            }
        }
        return parameter;
    }

    const getCategoriesObjectForSave = (categoriesObject) => {
        let categoriesValue = deepClone(categoriesObject);
        categoriesValue?.forEach((c) => {
            for(const k in c) {
                if(c["displaySeq"] === "Others") {
                    let totalAmount = 0;
                    c?.categories.forEach((o) => {
                        for(const l in o) {
                            if(o[l] === "Compensation") {
                                o["amount"] = formValues["compensationLossofOfficeAmount"];
                                totalAmount += !Utility.isEmpty(formValues["compensationLossofOfficeAmount"]) ? parseInt(formValues["compensationLossofOfficeAmount"]) : 0;
                            } else if(l === "amount" && !Utility.isEmpty(formValues[o.displaySeq])) {
                                o[l] = formValues[o.displaySeq];
                                totalAmount += parseInt(formValues[o.displaySeq]);
                            }
                        }
                    })
                    c["amount"] = totalAmount;
                } else if(k === "amount" && !Utility.isEmpty(formValues[c.displaySeq])) {
                    c[k] = formValues[c.displaySeq];
                }
            }
        });
        return categoriesValue;
    }

    const getDateValueForSave = (details, key) => {
        if(!Utility.isEmpty(formValues[key])) {
            let dateValue = formValues[key];
            const formattedValue = moment(dateValue).format("YYYY-MM-DD");
            return formattedValue;
        } else {
            return details[key];
        }
    }

    const getComplainceObjectForSave = (details, key) => {
        let complianceObject = deepClone(details[key]);
        for(const k in complianceObject) {
            if(k === "employeeContribution") {
                complianceObject[k].mbmf = formValues["employeeMbmfContribution"];
                complianceObject[k].cpfContribution = formValues["employeeCpfContribution"] 
            }
        }
        return complianceObject;
    }

    const getCheckBoxField = (field) => {
        return(
            <>
                <div className="cursor-hand" onClick={() => onCheck(field)} >
                    <DKCheckMark
                        isSelected={formValues[field.columnCode]}
                        color="bg-app"
                        disabled={field.readOnly}
                    />
                </div>
                <DKLabel className="ml-s" text={field.name} />
                {field.hasTooltip && !Utility.isEmpty(field.tooltipText) && (
                    <DKTooltipWrapper
                        content={field.tooltipText}
                        tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                    >
                        <DKIcon
                            src={ic_info_message}
                            className="ml-s ic-s ml-r mt-xs cursor-hand "
                            style={{ opacity: 0.4 }}
                        />
                    </DKTooltipWrapper>
                )}
            </>
        )
    }

    const getRadioButtons = (field) => {
        return (
            field.radioButtonConfig.map((radioField, index) => {
                return (
                    <>
                        <div className="row" style={{ width: "auto" }}>
                            <DKRadioButton
                                isSelected={radioField.value === formValues[field.columnCode]}
                                color="bg-app"
                                onClick={() => {
                                    formValues[field.columnCode] = radioField.value;
                                    setFromValues(deepClone(formValues));
                                }}
                            />
                            <DKLabel className="ml-s mr-l" text={radioField.name} />
                        </div>
                    </>
                )
            })
        )
    }

    const getFields = (fields, sectionIndex) => {
        return(
            fields.map((field, fieldIndex) => {
                switch(field.columnCode) {
                    case "employeeNricFin":
                    return (
                        <>
                            <div className={`web-width-50 ${field.columnCode}`} id={field.columnCode}>
                                <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                    <MaskInput
                                        setRef={(ref) => ERF.ADD_EMPLOYEE[field.columnCode] = ref}
                                        showMask={mask}
                                        title={field.name}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        value={formValues[field.columnCode]}
                                        errorMessage={field.errMsg}
                                        readOnly={field.readOnly}
                                        required={getFieldRequired(field)}
                                        tooltip={{
                                            content: field.tooltipText,
                                            className: "warning-tooltip-prop",
                                        }}
                                        onChange={(value) => {
                                            onChange(value, fieldIndex, field, sectionIndex)
                                        }}
                                        canValidate={field.hasError}
                                        invalid={field.hasError}
                                    />
                                </div>
                            </div>

                        </>
                    );
                    default:
                        return (
                            <>
                                {
                                    (field.type === INPUT_TYPE.TEXT || field.type === INPUT_TYPE.NUMBER) && (
                                        <div className={`web-width-50 ${field.columnCode}`} id={field.columnCode}>
                                            <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                                <DKInput                                                    
                                                    title={field.name}
                                                    placeholder={field.name}
                                                    value={formValues[field.columnCode]}
                                                    type={field.type}
                                                    hasError={field.hasError}
                                                    labelClassName=" text-align-left "
                                                    onChange={(value) => {
                                                        onChange(value, fieldIndex, field, sectionIndex);
                                                    }}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                    required={getFieldRequired(field)}
                                                    readOnly={field.readOnly}
                                                    tooltip={{
                                                        content: field.tooltipText,
                                                        className: "warning-tooltip-prop",
                                                    }}
                                                    canValidate={field.hasError}
                                                    validator={(value) => {
                                                        return !field.hasError;
                                                    }}
                                                    errorMessage={field.errMsg}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    (field.type === INPUT_TYPE.DROPDOWN || field.type === INPUT_TYPE.MULTI_SELECT) && (
                                        <div className={`web-width-50 ${field.columnCode}`} id={field.columnCode}>
                                            <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                                <DKInput
                                                    title={field.name}
                                                    placeholder={field.name}
                                                    value={formValues[field.columnCode]}
                                                    formatter={(field) => {
                                                        /** How to render a selected option in case of object **/
                                                        return field.name;
                                                    }}
                                                    type={field.type}
                                                    hasError={field.hasError}
                                                    labelClassName=" text-align-left "
                                                    onChange={(value) => {
                                                        onChange(value, fieldIndex, field, sectionIndex);
                                                    }}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                    required={getFieldRequired(field)}
                                                    readOnly={field.readOnly}
                                                    tooltip={{
                                                        content: field.tooltipText,
                                                        className: "warning-tooltip-prop",
                                                    }}
                                                    dropdownConfig={{
                                                        className: "",
                                                        style: {},
                                                        allowSearch:
                                                            field.options && field.options.length > 6
                                                                ? true
                                                                : false,
                                                        searchableKey: "name",
                                                        data: field.options,
                                                        renderer: (index, obj) => {
                                                            /** How to render value in Dropdown in case of object **/
                                                            return <DKLabel text={`${obj.name}`} />;
                                                        },
                                                        multiSelect: false,
                                                        
                                                    }}
                                                    canValidate={field.hasError}
                                                    validator={(value) => {
                                                        return !field.hasError;
                                                    }}
                                                    errorMessage={field.errMsg}
                                                />
                                            </div>

                                        </div>
                                    )
                                }
                                {
                                    field.type === INPUT_TYPE.RADIO_BUTTON && (
                                        <div className={`web-width-50 ${field.columnCode}`} id={field.columnCode}>
                                            <div className="column p-h-l" style={{ width: "90%" }}>
                                                <DKLabel className="ml-s mr-l" text={field.name} />
                                                <div className="row p-v-l ">
                                                    {getRadioButtons(field)}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    field.type === INPUT_TYPE.CHECKBOX && (
                                        <div className="web-width-50" id={field.columnCode}>
                                            <div
                                                className="row p-h-l p-v-l"
                                                style={{ }}
                                                key={field.columnCode}
                                            >
                                                {getCheckBoxField(field)}  
                                            </div>

                                        </div>
                                    )
                                }
                                {
                                    (field.type === INPUT_TYPE.DATE) && (
                                        <div className={`web-width-50 ${field.columnCode}`} id={field.columnCode}>
                                            <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                                <DKInput                                                    
                                                    title={field.name}
                                                    placeholder={field.name}
                                                    value={formValues[field.columnCode]}
                                                    type={field.type}
                                                    hasError={field.hasError}
                                                    labelClassName=" text-align-left "
                                                    onChange={(value) => {
                                                        onChange(value, fieldIndex, field, sectionIndex);
                                                    }}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                    required={getFieldRequired(field)}
                                                    readOnly={field.readOnly}
                                                    tooltip={{
                                                        content: field.tooltipText,
                                                        className: "warning-tooltip-prop",
                                                    }}
                                                    /* Commenting can be used further
                                                    canValidate={field.hasError}
                                                    validator={(value) => {
                                                        return !field.hasError;
                                                    }}
                                                    errorMessage={field.errMsg}
                                                    */
                                                />
                                                {field.hasError && (
                                                    <DKLabel
                                                        // className="pl-s fs-s unselectable text-red"
                                                        text={field.errMsg}
                                                        className="text-red ml-xs mt-xs"
                                                        style={{ fontSize: 11 }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        )
                }
            })
        )
    }

    const getSections = () => {
        return (
            IR8AFormConfig.map((section, sectionIndex) => {
                return (
                    <>
                        <div className="mt-xl parent-width bg-white border-radius-s card-shadow-form">
                            <DKExpandableWrapper
                                id="1"
                                title={section.title}
                                className="collapsable"
                                expanded={section.defaultState === "expanded"}
                                headerStyle={{ padding: "20px" }}
                            >
                                <DKLine className="bg-line-2" />
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                    className=" parent-width mb-s pb-m pt-s"
                                >
                                    {getFields(section.fields, sectionIndex)}
                                </div>
                            </DKExpandableWrapper>
                        </div>
                    </>
                )
            })
        )
    }

    const getHeader = () => {
        return (
            <div className="row justify-content-between p-h-m">
                <div className="row">
                    <DKLabel
                        text={"Edit IR8A Form"}
                        className="fw-b fs-m"
                    />
                    {isLoading && <DKSpinner className="pl-s" />}
                </div>
                <div className="row width-auto">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={() => {
                            props.onClose(false);
                        }}
                    />
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-r"
                        onClick={() => {
                            onSave();
                        }}
                    />
                </div>
            </div>
        );
    };

    return(
        <>
            <div className=" transparent-background-light">
                <div className="p-h-r pt-r pb-xl popup-window" style={{maxWidth:"60%", width:"100%"}}>
                    <div className="popup-wrapper parent-width parent-height">
                    {getHeader()}
                    <div className="p-m">{getSections()}</div>
                    </div>
                </div>

            </div>
        </>
    )

}

export default IR8AForm;